import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './Badge.scss';

const BORDER = ['primary', 'secondary', 'gray'];
const TEXT = ['primary', 'secondary', 'gray'];

class Badge extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    border: PropTypes.oneOf(BORDER),
    text: PropTypes.oneOf(TEXT),
    multiple: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    border: 'gray',
    text: 'gray',
    multiple: false,
  };

  render() {
    const { className, border, text, multiple, children } = this.props;

    return (
      <div
        className={classnames(
          'common-badge',
          className,
          `common-badge--border-${border}`,
          `common-badge--text-${text}`,
          {
            'common-badge--multiple': multiple,
          }
        )}
      >
        {children}
      </div>
    );
  }
}

export default Badge;



// WEBPACK FOOTER //
// ./src/components/common/badge/Badge.js